import {makeStyles} from "@material-ui/core";

export default function css() {

    var Background = '/images/watermarkLine.png';

    return makeStyles(theme => ({
        root: {
            padding: '55px'
        },
        paper: {
            position: 'absolute',
            width: 850,
            height: 700,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            overflowY: 'auto',
            padding: 20,
        },
        scroll: {
            height: 800,
        },
        modalPDF: {
            backgroundImage: `url(${Background})`,
            padding: 20,
            height: 1100,
            color: 'black'
        },
        container: {
            display: 'flex',
        },
        fixed: {
            width: 600,
        },
        flex_item: {
            flexGrow: 1,
            float:  'right'
        },
        tableBorder: {
            border: '1px solid black',
        }
    }));

}